// Services
import callAPI from "../callApi";
import path from "../variables";

const Files = {
	getAll: (params?: any) =>
		callAPI("GET", `${path.base}/files${params ? params : ""}`, "", "getting all files"),
	upload: (params: string, data:any, config?:any) =>
			callAPI("UPLOAD", `${path.base}/files/upload${params ? params : ""}`, data, "upload a file", config),
};

export default Files;
